/* Aretina: mouse drag-to-scroll for .carousel--scroll-desktop tracks.
   Native touch swipe on mobile/trackpads keeps working — this only adds
   pointer/mouse drag behavior on devices that don't do it natively. */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 6; // px before we treat a click as a drag

  function initTrack(track) {
    if (!track || track.dataset.dragInit === '1') return;
    track.dataset.dragInit = '1';

    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;
    var pointerId = null;

    function onPointerDown(e) {
      // Only react to primary mouse / pen — leave touch to native scroll
      if (e.pointerType === 'touch') return;
      if (e.button !== undefined && e.button !== 0) return;

      isDown = true;
      didDrag = false;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      pointerId = e.pointerId;
      // NOTE: no setPointerCapture aquí. Capturar en pointerdown re-targetea
      // el `click` sintetizado al track y mata la navegación del <a> interno
      // aunque el usuario solo haya hecho un click. Solo capturamos una vez
      // que sabemos que es drag real (ver onPointerMove).
    }

    function onPointerMove(e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(pointerId); } catch (_) {}
      }
      if (didDrag) {
        track.scrollLeft = startScrollLeft - dx;
        e.preventDefault();
      }
    }

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      if (pointerId !== null) {
        try { track.releasePointerCapture(pointerId); } catch (_) {}
        pointerId = null;
      }
      if (didDrag) {
        // Keep .is-dragging for one frame so the next 'click' is swallowed,
        // then remove it.
        var t = track;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { t.classList.remove('is-dragging'); });
        });
      }
    }

    function onClickCapture(e) {
      if (track.classList.contains('is-dragging')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    function onDragStart(e) { e.preventDefault(); }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('click', onClickCapture, true);
    track.addEventListener('dragstart', onDragStart);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var tracks = scope.querySelectorAll('.featured-collection--scroll-desktop .grid.carousel--scroll-desktop');
    for (var i = 0; i < tracks.length; i++) initTrack(tracks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
